import type { DataStatusLineItems } from 'c-sdk';
import { baseInitialState, createBaseSlice } from 'c-data';
import type { DataStatusLineItemsState } from './Data_Status_Line_Items-types';

const initialState: DataStatusLineItemsState = { ...baseInitialState };

const additionalReducers = {
    // example: (state: DataStatusLineItemsState, action: PayloadAction<string>): DataStatusLineItemsState => state,
};

const slice = createBaseSlice<
    DataStatusLineItems,
    DataStatusLineItemsState,
    typeof additionalReducers
>({
    name: 'data_Status_Line_Items',
    entityName: 'DataStatusLineItems',
    initialState,
    reducers: additionalReducers,
});

const data_Status_Line_ItemsSlice = {
    data_Status_Line_ItemsActions: slice.slice.actions,
    data_Status_Line_ItemsReducer: slice.slice.reducer,
    data_Status_Line_ItemsAdapter: slice.adapter,
    data_Status_Line_ItemsSelectors: slice.selectors,
    data_Status_Line_ItemsThunks: slice.thunks,
};

export const {
    data_Status_Line_ItemsReducer,
    data_Status_Line_ItemsActions,
    data_Status_Line_ItemsAdapter,
    data_Status_Line_ItemsSelectors,
    data_Status_Line_ItemsThunks,
} = data_Status_Line_ItemsSlice;
